import React from 'react';

function About() {
  return (
    <div className='about-us'>
      <header>
        <div className="overlay-bg-4"></div>
        <h1>About Us</h1>
      </header>
      <main>
        <div className="container" style={{ padding: "4rem" }}>
          <p>ACE EDUVILLE is a dynamic educational institution committed to fostering academic excellence and holistic development. Our mission is to empower students with knowledge, skills, and values that prepare them for success in a rapidly changing world.</p>

          <p>At ACE EDUVILLE, we believe in personalized learning, where each student is supported according to their unique strengths, interests, and learning styles. Our dedicated team of educators are passionate about creating engaging and interactive learning experiences that inspire curiosity, critical thinking, and creativity.</p>

          <p>We offer a comprehensive range of educational programs, including primary, secondary, and higher secondary education, as well as specialized courses in various disciplines. Our curriculum is designed to align with international standards while also incorporating innovative teaching methodologies and technology-enhanced learning resources.</p>

          <p>n addition to academic excellence, we place great emphasis on character development and extracurricular activities. Through our diverse range of clubs, sports teams, and community service initiatives, students have the opportunity to develop leadership skills, teamwork, and social responsibility.</p>

          <p>At ACE EDUVILLE, we strive to create a vibrant learning community where students feel valued, challenged, and supported to reach their full potential. We are committed to continuous improvement and excellence in all aspects of our educational program, ensuring that our students are well-prepared to thrive in the 21st century.</p>          
        </div>
      </main>
    </div>
  )
}

export default About;